import "./ShowOnboardingStep.css";

import { Breadcrumb, Button, message } from "antd";
import { BiEdit } from "react-icons/bi";
import { BsTrash } from "react-icons/bs";
import { Link, useLocation, useNavigate } from "react-router-dom";

import { deleteOnboardingStep, useAppSelector } from "../../../_lib/_store";
import { stripHtml } from "../../../_lib/_utils";

export const ShowOnboardingStepPage = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const { isLoading } = useAppSelector((state) => state.package);

  const navigate = useNavigate();
  const { state } = useLocation();

  const onboardingStepObj = state?.onboardingStep;

  const handleDelete = async () => {
    const res = await deleteOnboardingStep(messageApi, onboardingStepObj?.id);
    if (res) {
      navigate("/onboarding-step");
    }
  };

  return (
    <>
      {contextHolder}
      <div className="createCategory">
        <Breadcrumb
          items={[
            {
              title: <Link to="/dashboard">Dashboard</Link>,
            },
            {
              title: <Link to="/onboarding-step">Onboarding Step</Link>,
            },
            {
              title: "Show",
            },
          ]}
        />

        <div className="titleHeader">
          <h2 className="title">Show</h2>
          <div className="actionButton">
            <Button
              icon={<BiEdit />}
              size="large"
              onClick={() =>
                navigate(`/onboarding-step/edit`, {
                  state: { onboardingStep: state?.onboardingStep },
                })
              }
            >
              Edit
            </Button>
            <Button
              icon={<BsTrash />}
              size="large"
              onClick={handleDelete}
              loading={isLoading}
            >
              Delete
            </Button>
          </div>
        </div>

        <div className="form">
          <div className="row">
            <p className="label">Name</p>
            <p className="value">{stripHtml(onboardingStepObj?.title)}</p>
          </div>
          <div className="row">
            <p className="label">Id</p>
            <p className="value">{onboardingStepObj?.id}</p>
          </div>
          <div className="row">
            <p className="label">Description</p>
            <p className="value">{stripHtml(onboardingStepObj?.description)}</p>
          </div>
          <div className="row">
            <p className="label">Step Key</p>
            <p className="value">{onboardingStepObj?.stepKey}</p>
          </div>
          <div className="row">
            <p className="label">Order</p>
            <p className="value">{onboardingStepObj?.order}</p>
          </div>
          <div className="row">
            <p className="label">Parent Id</p>
            <p className="value">
              {stripHtml(onboardingStepObj?.parent?.title)}
            </p>
          </div>
          <div className="row">
            <p className="label">Video Url</p>
            <p className="value">{onboardingStepObj?.videoUrl}</p>
          </div>
          <div className="row">
            <p className="label">Tips</p>
            <div className="tagBox">
              {onboardingStepObj?.tips?.map((v: string, i: number) => {
                return (
                  <div key={i} className="row">
                    <p className="label">{i + 1}</p>
                    <p className="value">{v}</p>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="row">
            <p className="label">Checkbox Tip Bar</p>
            <p className="value">{onboardingStepObj?.checkboxTipBar}</p>
          </div>
        </div>
      </div>
    </>
  );
};
